// extracted by mini-css-extract-plugin
export default {"negative":"Negative-module__negative__nCz1687","copilotRun":"Negative-module__copilotRun__OEKhiNS"};